import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import RevenueSchedulesTab from './income/RevenueSchedulesTab';
import RevenueRecognitionsTab from './income/RevenueRecognitionsTab';
import RevenueRecurringTab from './income/RevenueRecurringTab';

const TABS = [
  { value: 'schedules', label: 'Revenue Schedules', Component: RevenueSchedulesTab },
  { value: 'recognitions', label: 'Recognitions', Component: RevenueRecognitionsTab },
  { value: 'recurring', label: 'Recurring', Component: RevenueRecurringTab },
];

// Income: deferred revenue recognition (config/ledger.php section
// 'income'). A schedule bills/collects a lump sum once and recognises it
// into income over a period range; posting the schedule generates the
// individual recognitions. Distinct from Student Receivables (which posts
// fee revenue immediately) - this is for revenue that spans terms/periods.
const Income = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('schedules');

  if (!can(RESOURCES.LEDGER.INCOME, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Income.</Alert>;
  }

  const Active = TABS.find((t) => t.value === tab)?.Component;

  return (
    <Box>
      <ModulePageHeader
        title="Income"
        subtitle="Deferred revenue schedules, recognitions and recurring revenue templates"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs value={tab} onChange={(_, v) => v && setTab(v)}>
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {Active && <Active />}
    </Box>
  );
};

export default Income;
